module.exports = __webpack_public_path__ + "static/media/global-g-a-p-seeklogo.5581f173.svg";